import React, { useState } from "react";
import s from "./InvestmentPolicy.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Table } from "antd";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { useTranslation } from "react-i18next";
import { t } from "i18next";

const InvestmentPolicy = () => {
  const [chapter, setChapter] = useState(1);
  const [active, setActive] = useState(1);
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  const columns = [
    {
      title: "",
      dataIndex: "key",
      width: 50,
    },
    {
      title: t("Цели"),
      dataIndex: `goals`,
      width: 400,
    },
    {
      title: t("Описание цели, критерии"),
      dataIndex: `description`,
      width: 600,
    },
  ];

  const dataSource = [
    {
      key: "1",
      goals: t("Импортозамещение"),
      description: (
        <div>
          {t(
            "Замещение импортируемых в Кыргызскую Республику товаров с помощью локализации производства внутри страны, как частично, так и полностью."
          )}
        </div>
      ),
    },
    {
      key: "2",
      goals: t("Поддержка экспортоориентированных производств"),
      description: (
        <div>
          {t(
            "Продвижение экспортной продукции с целью улучшения внешнеторговой позиции Кыргызской Республики."
          )}
        </div>
      ),
    },
    {
      key: "3",
      goals: t("Кластеризация экономики"),
      description: (
        <div>
          {t("Создание и развитие устойчивых цепочек добавленной стоимости.")}
        </div>
      ),
    },
    {
      key: "4",
      goals: (
        <div>
          {t(
            "Создание и развитие производств с более высокой добавленной стоимостью"
          )}
        </div>
      ),
      description: (
        <div>
          {t(
            "Повышение вклада в экономический рост и диверсификация экономики Кыргызской Республики."
          )}
        </div>
      ),
    },
    {
      key: "5",
      goals: <div>{t("Инновационность проектов")}</div>,
      description: (
        <div>
          {t(
            "Организация технологии/производства в Кыргызской Республике с акцентом на инновационные и передовые решения."
          )}
        </div>
      ),
    },
    {
      key: "6",
      goals: (
        <div>
          {t(
            "Взаимодействие между Кыргызской Республикой и Азербайджанской Республикой"
          )}
        </div>
      ),
      description: (
        <div>
          {t(
            "Эффективное использование возможностей двустороннего сотрудничества."
          )}
        </div>
      ),
    },
    {
      key: "7",
      goals: <div>{t("Расширение источников инвестирования")}</div>,
      description: (
        <div>
          {t(
            "Финансирование инвестиционных проектов совместно с международными финансовыми институтами, финансово- кредитными организациями, иностранными инвесторами и другими заинтересованными сторонами."
          )}
        </div>
      ),
    },
    {
      key: "8",
      goals: <div>{t("Развитие новых направлений")}</div>,
      description: (
        <div>
          {t(
            "Организация производства, использующего передовые технологии (в т.ч. в области «зеленого финансирования, инноваций и цифровых технологий)"
          )}
        </div>
      ),
    },
  ];

  const columns2 = [
    {
      title: "",
      dataIndex: "key",
      width: 300,
    },
    {
      title: t("Показатель"),
      dataIndex: `indicator`,
      width: 400,
    },
    {
      title: t("Методология расчета"),
      dataIndex: `metodology`,
      width: 600,
    },
    {
      title: t("Пороговый уровень"),
      dataIndex: `critical_level`,
      width: 100,
    },
  ];

  const dataSource2 = [
    {
      key: (
        <strong style={{ lineHeight: 1.8 }}>
          {t("Доходность на уровне проекта")}
        </strong>
      ),
      indicator: <div>{t("Внутренняя норма доходности (IRR)")}</div>,
      metodology: (
        <div>
          {t(
            "Ставка дисконтирования, при которой NPV от всех денежных потоков в рамках проекта равен нулю (%)"
          )}
        </div>
      ),
      critical_level: "≥8%",
    },
    {
      key: (
        <strong style={{ lineHeight: 1.8 }}>
          {t("Доходность сделки для АКФР")}
        </strong>
      ),
      indicator: <div>{t("Внутренняя норма доходности (IRR)")}</div>,
      metodology: (
        <div>
          {t(
            "Ставка дисконтирования, при которой NPV от всех денежных потоков для Компании равен нулю (%)"
          )}
        </div>
      ),
      critical_level: "≥8%",
    },
    {
      key: "",
      indicator: <div>{t("Мультипликатор капитала (MOIC)")}</div>,
      metodology: (
        <div>
          {t(
            "Суммарная стоимость всех полученных средств инвестора / вложенный капитал"
          )}
        </div>
      ),
      critical_level: "≥1,1-2,5х",
    },
    {
      key: "",
      indicator: <div>{t("Горизонт выхода из инвестиции")}</div>,
      metodology: (
        <div>
          {t(
            "Количество лет, через которое предполагается выход АКФР с достижением рассчитанного значения MOIC"
          )}
        </div>
      ),
      critical_level: t("до 7 лет"),
    },
  ];

  const columns3 = [
    {
      title: "№",
      dataIndex: "key",
      width: 50,
    },
    {
      title: "Стоп-факторы",
      dataIndex: `stop-factors`,
      width: 400,
    },
    {
      title: "Описание",
      dataIndex: `description`,
      width: 600,
    },
  ];

  const dataSource3 = [
    {
      key: "1",
      goals: (
        <div>
          Принадлежность к определенной индустрии/сегменту Военно-промышленный
          комплекс включая производство изделий двойного назначения, военной
          формы, прочего обмундирования изделий из текстиля.
        </div>
      ),
      description: (
        <div>
          Военно-промышленный комплекс включая производство изделий двойного
          назначения, военной формы, прочего обмундирования изделий из текстиля.
          ​ Принудительный и детский труд, игорный бизнес, казино и пр.
        </div>
      ),
    },
    {
      key: "2",
      goals: <div>Ранняя стадия инвестиционного проекта</div>,
      description: (
        <div>
          Проекты, по которым не разработан бизнес-план, финансовая модель и пр.
        </div>
      ),
    },
    {
      key: "3",
      goals: <div>Наличие репутационного риска</div>,
      description: (
        <div>Создание и развитие устойчивых цепочек добавленной стоимости.</div>
      ),
    },
  ];

  const investmentPolicy = [
    {
      id: 1,
      title: t("Инвестиционные принципы"),
      text: (
        <div>
          <div className={s.text_item}>
            {t(
              "Настоящая Инвестиционная политика Азербайджано-Кыргызского Фонда развития"
            )}
          </div>
          <div className={s.text_item}>
            {t(
              "При осуществлении инвестиционной деятельности АКФР руководствуется рядом инвестиционных принципов для достижения следующих основных целей"
            )}
          </div>{" "}
          <div className={s.text_item}>
            {t(
              "Инвестиционные принципы направлены на обеспечение стабильного инвестиционного портфеля путем получения приемлемого уровня доходности инвестирования при ограниченном уровне риска."
            )}
          </div>
        </div>
      ),
    },
    {
      id: 2,
      title: t("Соответствие инвестиционных проектов целям АКФР"),
      text: (
        <div>
          <div className={s.text_item}>
            {t(
              "АКФР инвестирует в различные проекты, которые соответствуют одной или нескольким целям, заложенным в его деятельности."
            )}
          </div>
          <div className={s.text_item}>
            {t(
              "Определение количества целей, которым должен соответствовать проект, имеет важное значение для достижения целей АКФР и определяет весь диапазон потенциальных проектов."
            )}
            :
          </div>
        </div>
      ),
    },
    {
      id: 3,
      title: t("Приоритетные отрасли / сегменты"),
      text: (
        <div className={s.text_item}>
          {t(
            "Наиболее привлекательными для рассмотрения считаются существующие секторы экономики, характеризующиеся стабильным и растущим спросом / потреблением, а также новые отрасли с высоким потенциалом роста."
          )}
          :
          <div className={s.text_item}>
            ‑ {t("agro")}; <br />‑ {t("water")}; <br />‑ {t("healthcare")};{" "}
            <br />‑ {t("auto")}; <br />‑ {t("science")};
            <br />‑ {t("gas")}; <br />‑ {t("chemical")}; <br />‑ {t("textile")};{" "}
            <br />‑ {t("manufacturing")}; <br />‑ {t("mining")}; <br />‑{" "}
            {t("transportation")}; <br />‑ {t("residentialConstruction")};
            <br /> ‑ {t("trade")}; <br />‑ {t("entrepreneurshipDevelopment")};{" "}
            <br />‑ {t("energySector")}; <br />‑ {t("infrastructureGrowth")};{" "}
            <br /> ‑ {t("it")}; <br />‑ {t("tourism")}; <br />‑ {t("other")}
          </div>
          {t(
            "При этом АКФР не ограничивается инвестированием только в указанные отрасли. Он также может рассмотреть и инвестировать в проекты в других секторах экономики, при условии их соответствия целям и инвестиционным критериям АКФР."
          )}
        </div>
      ),
    },
    {
      id: 4,
      title: t("Целевая география проектов"),
      text: (
        <div>
          {t(
            "АКФР рассматривает возможность инвестирования в проекты, которые предполагают формирование производственных мощностей / активов на территории Кыргызской Республики."
          )}
        </div>
      ),
    },
    {
      id: 5,
      title: t("Формат финансирования"),
      text: (
        <div>
          <div className={s.text_item}>
            {t(
              "Оптимальный формат финансирования для АКФР предусматривает вхождение в капитал компании, предоставление долгового финансирования 1 в случае необходимости, в том числе с возможностью конвертации долга в долевое участие в капитале компании."
            )}
          </div>
          <div className={s.text_item}>
            {t(
              "При этом участие в капитале является приоритетным способом финансирования, а заемное финансирование используется в качестве дополнительного инструмента и применяется Компанией для хеджирования части доходности, только при условии обеспечения долга. Максимальное участие АКФР в проекте не более 49% от суммы проекта."
            )}
          </div>
        </div>
      ),
    },
    {
      id: 6,
      title: t("Управление рисками"),
      text: (
        <div>
          {t(
            "Управление рисками предполагает формулирование общего уровня риск-аппетита на уровне АКФР и последующее каскадирование этого уровня в конкретные ограничения для портфеля и отдельных инвестиций."
          )}
        </div>
      ),
    },
    {
      id: 7,
      title: t("Требования к финансовой доходности"),
      text: (
        <div>
          <div className={s.text_item}>
            {t(
              "При осуществлении процесса отбора проектов в рамках инвестиционной деятельности АКФР оценивает показатели доходности как самих инвестиционных проектов, так и доходности сделки для Фонда."
            )}
          </div>
        </div>
      ),
    },
    {
      id: 8,
      title: t(
        "Степень участия в деятельности компаний, входящих в инвестиционный портфель АКФР"
      ),
      text: (
        <div>
          <div className={s.text_item}>
            {t(
              "АКФР активно участвует в принятии стратегических решений компаниями, входящими в его инвестиционный портфель, с помощью двух основных рычагов"
            )}
            :
          </div>
          <div className={s.text_item}>
            <strong>
              1){" "}
              {t(
                "Путем активного участия в органах управления компаний и тесного взаимодействия АКФР с их менеджментом"
              )}
              :
            </strong>
            <li className={s.text_item} style={{ marginLeft: "25px" }}>
              {t(
                "Представитель АКФР входит в состав совета директоров (наблюдательных советов) и других ключевых органах управления компаний, где обсуждаются и принимаются стратегически важные решения"
              )}
              ;
            </li>
            <li className={s.text_item} style={{ marginLeft: "25px" }}>
              {t(
                "В случае возникновения риска невозврата вложенных инвестиций в период реализации проекта при необходимости АКФР осуществляет взаимодействие с компанией по операционным вопросам, поддерживает активную коммуникацию с компаниями, анализирует выполнение стратегии и операционные показатели, обсуждает возможные улучшения и оптимизации деятельности компаний"
              )}
            </li>
          </div>
          <strong>
            <div className={s.text_item}>
              2){" "}
              {t(
                "Путем установления ограничений и различных ковенант для компаний, включая право вето на ключевые решения"
              )}
              :
            </div>
          </strong>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Целевое расходование привлеченных средств")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {" "}
            {t("Соблюдение законодательства")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Своевременность и полнота уплаты налогов")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Своевременная подготовка отчетности и пр")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Найм генерального директора / топ-менеджмента компании")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Уровень компенсации для топ-менеджмента")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Смена аудитора")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {" "}
            {t("Реорганизация компании")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Слияния и поглощения")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Отчуждение активов компании")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Привлечение долгового финансирования")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Капитальные расходы")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Инвестирование средств")}
          </li>
          <li
            className={s.text_item}
            style={{ marginLeft: "25px", marginBottom: "5px" }}
          >
            {t("Выплата дивидендов")}
          </li>
          <div className={s.text_item}>
            {t(
              "При необходимости АКФР может также вовлекаться в определенные аспекты операционной деятельности компаний, в том числе с помощью внешних экспертов, которые обладают специализированными знаниями и опытом в определенных областях бизнеса."
            )}
          </div>
        </div>
      ),
    },

    {
      id: 10,
      title: t("Подход к отбору инвестиционных проектов"),
      text: (
        <div>
          <div className={s.text_item}>
            {t(
              "Отбор проектов для инвестирования осуществляется поэтапно с использованием жестких и гибких критериев"
            )}
            :
          </div>
          <strong>{t("Этап 1: Жесткие критерии отбора")}</strong>
          <div>
            {t(
              "На этом этапе происходит первичный отсев проектов, и далее рассматриваются только те, которые соответствуют следующим жестким критериям"
            )}
            :
          </div>
          <li className={s.text_item} style={{ marginLeft: "25px" }}>
            <strong>{t("Отсутствие стоп-факторов")}:</strong>{" "}
            {t(
              "проекты, содержащие хотя бы один стоп- фактор, исключаются из дальнейшего рассмотрения, даже при наличии высоких финансовых и прочих показателей. Ключевыми стоп-факторами являются"
            )}
            :
          </li>
          <li className={s.text_item} style={{ marginLeft: "25px" }}>
            <strong>{t("Соответствие стратегическим целям АКФР")}.</strong>{" "}
            {t(
              "Проекты должны соответствовать целям деятельности АКФР, определенным Уставом АКФР."
            )}
          </li>
          <div className={s.text_item}>
            <strong>{t("Этап 2: Гибкие критерии отбора")}</strong>
            <div className={s.text_item}>
              {t(
                "На этом этапе происходит комплексный анализ проекта и принимается окончательное решение об инвестировании на основе следующих гибких критериев"
              )}
              :
            </div>
            <li className={s.text_item} style={{ marginLeft: "25px" }}>
              <strong>
                {t("Соответствие требованиям по финансовой доходности")}.
              </strong>{" "}
              {t(
                "Проект должен соответствовать критериям инвестиционной привлекательности, включая показатели доходности (IRR) и другие финансовые показатели (пункт 7 настоящей Политики)"
              )}
              ;
            </li>
            <li className={s.text_item} style={{ marginLeft: "25px" }}>
              <strong>
                {t(
                  "Удовлетворительность прочих аспектов деятельности компании"
                )}
                .
              </strong>
              &nbsp;
              {t(
                "Всесторонний анализ деятельности компании включает оценку её бизнес- модели, рынка, менеджмента, финансового состояния и других аспектов, которые могут влиять на успешность проекта и его соответствие целям АКФР."
              )}
            </li>
          </div>
        </div>
      ),
    },
    {
      id: 11,
      title: t("Стратегия выхода из инвестиционных проектов"),
      text: (
        <div>
          <div className={s.text_item}>
            {t(
              "Целевыми способами выхода из инвестиционных проектов для АКФР являются: продажа доли компании стратегическому партнеру или другому инвестору, который имеет 9 стратегический интерес в данной отрасли или бизнесе; иные способы выхода из инвестиционного проекта."
            )}
          </div>
          <div className={s.text_item}>
            {t(
              "Принятие решения о сроках выхода из инвестиционного проекта и требуемой доходности осуществляется на основе тщательного анализа и оценки различных факторов в момент одобрения проекта."
            )}
          </div>
          <div className={s.text_item}>
            {t(
              "При этом возможен досрочный выход АКФР из инвестиционного проекта при следующих случаях"
            )}
            :
            <li className={s.text_item} style={{ marginLeft: "25px" }}>
              {t(
                "Неэффективность компании: если компания не демонстрирует ожидаемого уровня эффективности и не имеет потенциала для дальнейшего роста и развития"
              )}
              ;
            </li>
            <li className={s.text_item} style={{ marginLeft: "25px" }}>
              {t(
                "Наличие заинтересованного покупателя, который готов приобрести долю в компании по цене, обеспечивающей приемлемую доходность (IRR) для АКФР."
              )}
            </li>
            <li className={s.text_item} style={{ marginLeft: "25px" }}>
              {t("Прочие факторы")}.
            </li>
          </div>
          <div className={s.text_item}>
            {t(
              "Планирование способа выхода: Компания разрабатывает стратегию выхода еще до вхождения в капитал компании."
            )}
          </div>
        </div>
      ),
    },
  ];

  const downloadFile = async () => {
    const fileUrl = "/1.AKDF_Инвестиционная политика.pdf";
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "/1.AKDF_Инвестиционная политика.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openFileInNewWindow = (e, file) => {
    e.preventDefault();
    const fileUrl = file;
    window.open(fileUrl, "_blank");
  };
  return (
    <div>
      {width > 970 ? <Header /> : <MobileHeader />}
      <div className={s.investmentPolicy}>
        <h2 className={s.title}>{t("Инвестиционная политика")}</h2>
      </div>
      <div className={s.wrapper}>
        <div>
          {investmentPolicy.map((it) => (
            <li
              onClick={() => setChapter(it.id)}
              className={it.id === chapter ? s.active : s.chapter_title}
            >
              {it.title}
            </li>
          ))}
        </div>
        <div>
          <div className={s.chap_title}>
            {investmentPolicy.find((it) => it.id === chapter)?.title}
          </div>
          <div className={s.chap_text}>
            {investmentPolicy.find((it) => it.id === chapter)?.text}
            {chapter === 2 && (
              <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
              />
            )}

            {chapter === 7 && (
              <Table
                dataSource={dataSource2}
                columns={columns2}
                pagination={false}
              />
            )}
          </div>
        </div>
      </div>
      <div className={s.documents_item}>
        <button
          className={s.btn_title}
          onClick={(e) =>
            openFileInNewWindow(e, "/1.AKDF_Инвестиционная политика.pdf")
          }
        >
          <FilePdfOutlined className={s.icon} /> &nbsp;{" "}
          {t("Инвестиционная политика").toUpperCase()}
        </button>
        <div className={s.btn} onClick={() => downloadFile()}>
          <DownloadOutlined className={s.downloadIcon} />
        </div>
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default InvestmentPolicy;
